export default __webpack_public_path__ + "static/media/Topo_alpha_bg.273ea816.png";